import styled from 'styled-components'
import {FastField} from 'formik'

import {fieldSpacing, inputFieldCss} from '../constants'

const AreaRange = styled.div`
  display: flex;
  height: 100%;
`

AreaRange.InputWrapper = styled.div`
  flex: calc((100% - ${fieldSpacing}) / 2) 0 0;

  &:first-child {
    margin-right: ${fieldSpacing};
  }
`

AreaRange.Input = styled(FastField)`
  ${inputFieldCss}
`

export default AreaRange
